var _path, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "382px",
    height: "512px",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 24.33 32.53",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.23 0h10.88l9.22 9.61v18.69c0 2.33-1.9 4.23-4.23 4.23h-15.87c-2.34 0-4.23-1.9-4.23-4.23v-24.07c0-2.34 1.89-4.23 4.23-4.23z",
    fill: "#251D36"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "15.1 0 15.1 9.53 24.33 9.53",
    fill: "#fff",
    fillOpacity: 0.30196
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.45 21.21h-8.57c-0.4 0-0.72 0.32-0.72 0.72 0 0.39 0.32 0.71 0.72 0.71h8.57c0.4 0 0.72-0.32 0.72-0.71 0-0.4-0.32-0.72-0.72-0.72zm0 2.86h-8.57c-0.4 0-0.72 0.32-0.72 0.72 0 0.39 0.32 0.71 0.72 0.71h8.57c0.4 0 0.72-0.32 0.72-0.71 0-0.4-0.32-0.72-0.72-0.72zm-4.36-8.57h-4.21c-0.4 0-0.72 0.31-0.72 0.71s0.32 0.71 0.72 0.71h4.21c0.4 0 0.72-0.31 0.72-0.71s-0.32-0.71-0.72-0.71zm4.36 2.85h-8.57c-0.4 0-0.72 0.32-0.72 0.72 0 0.39 0.32 0.71 0.72 0.71h8.57c0.4 0 0.72-0.32 0.72-0.71 0-0.4-0.32-0.72-0.72-0.72z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.759ad80af59179602f28e62d3700a263.svg";
export { ForwardRef as ReactComponent };